export default "__VITE_ASSET__BYsWSGVW__"